import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const AgeContainer = styled.div`
  display: inline;
  .superscript {
    font-size: 50%;
    vertical-align: super;
  }
`;

class AgeCounter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      birthdate: Date.parse('02/14/1992'),
      intervalId: null,
      year: 0,
      milliseconds: 0
    };
  }

  renderAge() {
    var now = new Date;
    var duration = now - Date.parse('02/14/1992');
    var years = duration / 31556900000;

    var majorMinor = years.toFixed(9).toString().split('.');

    this.setState({
      year: majorMinor[0],
      milliseconds: majorMinor[1]
    });
  }

  componentDidMount() {
    var intervalId = setInterval(this.renderAge.bind(this), 100);
    this.setState({intervalId: intervalId});
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  render() {
    return(
      <AgeContainer>
        <span className="year">{this.state.year}</span>
        <span className="superscript">{this.state.milliseconds}</span>
      </AgeContainer>
    )
  }
}

export default AgeCounter


// WEBPACK FOOTER //
// ./src/components/Age/index.js